import { useState, useEffect, useRef } from "react";
import { Checkbox } from "antd";
import "./css/countrySelect.css";
import { FormatCurrency } from "../format/formatCurrency";

const CountrySelect = ({ options, value, onChange, disabled }) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    if (disabled) return;
    onChange(option);
    setOpen(false);
  };

  return (
    <div className="country-select" ref={wrapperRef}>
        <div 
            className={`country-select-display ${disabled ? "disabled" : ""}`}
            onClick={() => {
                if (disabled) return;
                setOpen(prev => !prev);
            }}
        >
            {value ? (
                <div className="selected-country-container" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <img
                    src={`https://flagcdn.com/w20/${value.country.toLowerCase()}.png`}
                    alt={value.countryName}
                    className="country-flag"
                    style={{ flexShrink: 0 }}
                />
                <span style={{ whiteSpace: 'nowrap' }}>{value.countryName}</span>
                <span style={{ marginLeft: '8px', color: '#555', fontWeight: '500', whiteSpace: 'nowrap' }}>
                    {FormatCurrency(value.availableBalance, value.currency)}
                </span>
                </div>
            ) : (
                <span>
                    {disabled ? "Veuillez d'abord choisir un business" : "Sélectionner le pays"}
                </span>
            )}
        </div>

        {open && !disabled &&  (
            <div className="country-select-dropdown">
                {options
                    ?.slice()
                    .sort((a, b) => b.availableBalance - a.availableBalance)
                    .map((opt, index) => {
                        const isTop = index === 0; // premier du classement
                        return (
                        <div
                            key={opt.id}
                            className={`country-option ${isTop ? "top-country" : ""}`}
                            onClick={() => handleSelect(opt)}
                        >
                            <div className="country-info">
                                <Checkbox checked={!!value && value.country === opt.country} className="circle-checkbox" />
                                <img
                                    src={`https://flagcdn.com/w20/${opt.country?.toLowerCase()}.png`}
                                    alt={opt.countryName}
                                    className="country-flag"
                                />
                                <span>{opt.countryName}</span>
                                {isTop && <span className="best-badge" title="Montant plus elevé">⭐</span>}
                            </div>
                            <span className="country-balance">
                                {FormatCurrency(opt.availableBalance, opt.currency)}
                            </span>
                        </div>
                        );
                })}
            </div>
        )}
    </div>
  );
};

export default CountrySelect;
